import { createFileRoute } from '@tanstack/react-router'

import { ActivitiesPage } from '@/components/pages/Activities/ActivitiesPage'

export const Route = createFileRoute('/e/$eventId/_dashboard/activities/')({
  component: ActivitiesPage,
})
